import React from 'react'
import styled, { StyledProps } from 'styled-components'
import { Button, ButtonFullProps } from '../Button/Button'
import { useTranslation } from 'react-i18next'
import { helpersColor } from '../../../helpers'
import { IconDownload } from '../../iconography/Icons/Icons'

const IconStyled = styled(IconDownload)<StyledProps<{}>>`
  color: ${({ theme }: StyledProps<{}>) => theme.color.accentApproving};
  transition: 0.1s color ease-out;

  button:hover & {
    color: ${({ theme }: StyledProps<{}>) => helpersColor.alphaColor(theme.color.accentApproving, 0.75)};
  }
`

const Link = styled.a<StyledProps<{ align: 'right' | 'left' | 'center' }>>`
  ${props => {
    switch (props.align) {
      case 'left':
        return {
          display: 'flex',
          marginRight: 'auto',
          marginTop: 'auto',
          justifySelf: 'flex-start',
        }
      case 'right':
        return {
          display: 'flex',
          marginLeft: 'auto',
          marginTop: 'auto',
          justifySelf: 'flex-end',
        }
      case 'center':
        return {
          display: 'flex',
          marginLeft: 'auto',
          marginRight: 'auto',
          marginTop: 'auto',
          justifySelf: 'center',
        }
    }
  }}
`

export type DownloadButtonProps = Omit<ButtonFullProps, 'intent' | 'size'> & {
  href: string
  text?: string
  align?: 'right' | 'left' | 'center'
  className?: string
}

export const DownloadButton: React.FC<DownloadButtonProps> = ({ href, text, className, align = 'left', ...props }) => {
  const { t } = useTranslation('ui')
  return (
    <Link href={href} className={className} align={align} download>
      <Button intent={'primary'} filled={true} {...props}>
        <IconStyled />
        {text || t('common.download')}
      </Button>
    </Link>
  )
}
